export const MODULE_LEVEL_TONE = {
  beginner: "bg-emerald-50 text-emerald-700",
  intermediate: "bg-amber-50 text-amber-700",
  advanced: "bg-slate-100 text-slate-700",
};


export const MODULE_CATALOG = [
  {
    code: "M1",
    title: "Module 1: Foundations of Theology",
    level: "beginner",
    description:
      "Build a clear foundation for understanding the Bible as one connected story. This module introduces the structure, chronology, and central message of Scripture from Genesis to Revelation.",
    explore: [
      "The structure of the Old and New Testament",
      "Creation, the Fall, covenant, and redemption",
      "Key biblical figures from Adam and Abraham to Moses, David, and Jesus",
    ],
    price: 1710,
    duration: "6 weeks / 1½ months",
    image: "/module-covers/module-1-cover.png",
    imageAlt: "Front cover for Module 1: Foundations of Theology",
  },
  {
    code: "M2",
    title: "Module 2: Intermediate Biblical Interpretation",
    level: "intermediate",
    description:
      "Deepen your understanding of the New Covenant and how God’s promise is fulfilled through Jesus Christ, the early church, and the spread of the Gospel.",
    explore: [
      "The New Covenant and its fulfilment in Christ",
      "The teachings, mission, and ministry of Jesus",
      "The early church, Paul’s missionary journeys, prophecy, and discipleship",
    ],
    price: 2490,
    duration: "8 weeks / 2 months",
    image: "/module-covers/module-2-cover.png",
    imageAlt: "Front cover for Module 2: Intermediate Biblical Interpretation",
  },
  {
    code: "M3",
    title: "Module 3: Thematic Theology and Church Governance",
    level: "intermediate",
    description:
      "Explore major themes in biblical history, theological development, church governance, and Christian witness. This module helps learners understand how the biblical story, church structures, denominations, and faithful service have shaped Christian practice across time.",
    explore: [
      "Thematic periods in Bible history and dispensational understanding",
      "Church governance, leadership roles, and Christian denominations",
      "Martyrdom, sacrifice, and the historical witness of the Church",
    ],
    price: 2490,
    duration: "8 weeks / 2 months",
    image: "/module-covers/module-3-cover.png",
    imageAlt: "Front cover for Module 3: Thematic Theology and Church Governance",
  },
  {
    code: "M4",
    title: "Module 4: Biblical Principles of Leadership and Spiritual Growth",
    level: "advanced",
    description:
      "Develop a biblical and practical understanding of Christian leadership, discipleship, ministry formation, and spiritual growth. This module guides learners through church leadership, ordination, women in ministry, and the work of the Holy Spirit.",
    explore: [
      "Bishopric, ordination, consecration, and the making of church leaders",
      "Discipleship, prayer, ministry preparation, and spiritual formation",
      "Women in ministry, Pentecostalism, Charismatism, and gifts of the Holy Spirit",
    ],
    price: 3150,
    duration: "10 weeks / 2½ months",
    image: "/module-covers/module-4-cover.png",
    imageAlt: "Front cover for Module 4: Biblical Principles of Leadership and Spiritual Growth",
  },
  {
    code: "M5",
    title: "Module 5: Foundations of Christian Doctrine and Spiritual Truth",
    level: "advanced",
    description:
      "Strengthen your understanding of core Christian doctrine and responsible biblical interpretation. This module explores the nature of God, the Trinity, Jesus Christ, the Holy Spirit, angels, preaching, hermeneutics, and deeper theological reflection.",
    explore: [
      "The Trinity, Christology, the Holy Spirit, and the doctrine of angels",
      "Homiletics, sermon preparation, and communicating biblical truth",
      "Hermeneutics, exegesis, apologetics, ontology, and careful interpretation of Scripture",
    ],
    price: 3150,
    duration: "10 weeks / 2½ months",
    image: "/module-covers/module-5-cover.png",
    imageAlt: "Front cover for Module 5: Foundations of Christian Doctrine and Spiritual Truth",
  },
];


export const MODULE_DISPLAY_INFO = Object.fromEntries(MODULE_CATALOG.map((module) => [module.code, module]));


export const getModuleDisplayInfo = (module = {}) => {
  const displayInfo = MODULE_DISPLAY_INFO[module?.code] || {};

  return {
    ...module,
    ...displayInfo,
    title: displayInfo.title || module?.title,
    price: module?.price ?? displayInfo.price,
  };
};


export const getOrderedModuleCatalog = (modules = []) => {
  if (!modules?.length) {
    return MODULE_CATALOG;
  }

  const mergedModules = modules.map(getModuleDisplayInfo);
  const knownCodes = new Set(mergedModules.map((module) => module.code));

  return [...mergedModules, ...MODULE_CATALOG.filter((module) => !knownCodes.has(module.code))];
};